"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewbuildingsList = require("./NewbuildingsList");
Object.keys(_NewbuildingsList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewbuildingsList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewbuildingsList[key];
    }
  });
});